// Redux action types
export const SET = 'one-state-addnew/set';
export const ADD = 'one-state-addnew/add';
export const ADDNOTIFICATION = 'one-state-addnew/notification';
export const RESETNOTIFICATION = 'one-state-addnew/resetnotification';
export const SETSPIN = 'one-state-addnew/spin';
export const REINIT = 'one-state-addnew/reinit';
